import Papa from "papaparse";

const HG_ID_HEADERS = ["hgid", "hg_id", "hg id", "hg company id", "company_id"];
/** Enough to hold the header row; the rest of the file is read server-side. */
const HEAD_BYTES = 64 * 1024;

export type HgIdColumn = {
  /** 0-based index of the HG ID column */
  columnIndex: number;
  columnCount: number;
  hasHeader: boolean;
};

const normalize = (value: unknown) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

/**
 * Finds the HG ID column from the file's first row only (files can be ~1GB, so
 * the browser never parses the whole thing): the column whose header is an HG
 * ID header, or the only column of a header-less single-column file.
 */
export async function detectHgIdColumn(file: File): Promise<HgIdColumn> {
  const head = await file.slice(0, HEAD_BYTES).text();
  const [firstRow = []] = Papa.parse<string[]>(head, {
    preview: 1,
    skipEmptyLines: "greedy",
  }).data;

  if (firstRow.length === 0) {
    throw new Error("The CSV is empty.");
  }

  const headerIndex = firstRow.findIndex((cell) =>
    HG_ID_HEADERS.includes(normalize(cell))
  );
  if (headerIndex !== -1) {
    return {
      columnIndex: headerIndex,
      columnCount: firstRow.length,
      hasHeader: true,
    };
  }
  if (firstRow.length === 1) {
    return { columnIndex: 0, columnCount: 1, hasHeader: false };
  }
  throw new Error("The CSV must have an HG ID column.");
}
